<div class="eiq-input-verify__container">
  <span class="fs__sm fw__500 label">
    {{ label() }} <span class="fs__xs caption">{{ hint() }}</span>
  </span>
  <mat-form-field appearance="outline" class="eiq-input__field" [subscriptSizing]="'dynamic'">
    @if (prefix()) {
      <span matPrefix>{{ prefix() }}</span>
    }
    <input
      matInput
      #input
      [attr.data-testid]="testId() ? testId() + '-input' : null"
      [type]="type()"
      autocomplete="false"
      [placeholder]="placeholder()"
      [value]="currentValue"
      [formControl]="control"
      [maxlength]="maxLength()"
      (input)="setValue($event)"
      (keyup.enter)="keyupEnter.emit()"
    />

    <div matSuffix class="eiq-input-verify__container__suffix">
      @if (loading$()) {
        <mat-spinner matSuffix diameter="20" [strokeWidth]="4" color="secondary"></mat-spinner>
      } @else if (control.touched && control.value && verified$()) {
        <fa-icon [icon]="verified$() === 'VALID' ? faCircleCheck : faCircleExclamation" [ngClass]="verified$() === 'VALID' ? 'success' : 'danger'"></fa-icon>
      }
    </div>
  </mat-form-field>
</div>

@if (!loading$()) {
  <div class="eiq-input-verify__container__error">
    @if (maxLength() || control.errors) {
      <mat-error><eiq-validation-text [formCtrl]="control"></eiq-validation-text></mat-error>

      @if (maxLength()) {
        <mat-hint class="fs__sm fw__400">{{ input?.value.length || 0 }}/{{ maxLength() }}</mat-hint>
      }
    }
  </div>
} @else {
  <div class="eiq-input-verify__container__check">
    <span class="fs__sm fw__400">Checking availability...</span>
  </div>
}
